import React, { Component } from 'react';
import { Route, Switch } from 'react-router';
import EventMain from './routes/EventMain';
import Promotion from './routes/Promotion';

/**
 * [4월 이벤트] 플레이 소감 작성 이벤트
 */
export default class PlayReview extends Component {
	render() {
		return (
			<Switch>
				<Route path='/play-review/main' component={EventMain} />
				<Route path='/play-review/promotion' component={Promotion} />
			</Switch>
		);
	}
}
